import { getSize } from '@lib/common';
import styled from 'styled-components';
import { CountDownV3Component } from './count-down.component';
import { SectionSummaryDetailV3Component } from './section-summary-detail-v3.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SummaryColumn = styled.div.withConfig({
  displayName: "section-summary-column-v3component__SummaryColumn",
  componentId: "sc-1hdhlkf-0"
})(["display:flex;flex-direction:column;gap:", ";height:100%;min-height:0;overflow:hidden;"], getSize('gap16'));
var CountdownContent = styled.div.withConfig({
  displayName: "section-summary-column-v3component__CountdownContent",
  componentId: "sc-1hdhlkf-1"
})(["flex-shrink:0;&:empty{display:none;}"]);
var SummaryContent = styled.div.withConfig({
  displayName: "section-summary-column-v3component__SummaryContent",
  componentId: "sc-1hdhlkf-2"
})(["display:flex;flex-direction:column;flex:1;min-height:0;overflow:hidden;"]);
export var SectionSummaryColumnV3Component = function SectionSummaryColumnV3Component(_ref) {
  var selectedSectionIndex = _ref.selectedSectionIndex,
      sectionSummaries = _ref.sectionSummaries,
      selectedSection = _ref.selectedSection,
      questions = _ref.questions,
      isLoadingQuestions = _ref.isLoadingQuestions,
      answeredQuestionIds = _ref.answeredQuestionIds,
      readonly = _ref.readonly,
      sectionLabels = _ref.sectionLabels,
      countDownLabels = _ref.countDownLabels,
      updateSelectedSection = _ref.updateSelectedSection,
      shouldAutoSelectFirstQuestion = _ref.shouldAutoSelectFirstQuestion,
      hideOverviewHeader = _ref.hideOverviewHeader,
      onQuestionSelected = _ref.onQuestionSelected,
      onSelectCarouselQuestion = _ref.onSelectCarouselQuestion,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(SummaryColumn, {
    children: [/*#__PURE__*/_jsx(CountdownContent, {
      children: children ? children : /*#__PURE__*/_jsx(CountDownV3Component, {
        labels: countDownLabels
      })
    }), /*#__PURE__*/_jsx(SummaryContent, {
      "data-testid": "section-summary-content",
      children: /*#__PURE__*/_jsx(SectionSummaryDetailV3Component, {
        questions: questions,
        isLoadingQuestions: isLoadingQuestions,
        selectedSectionIndex: selectedSectionIndex,
        sectionSummaries: sectionSummaries,
        selectedSection: selectedSection,
        readonly: readonly,
        labels: sectionLabels,
        answeredQuestionIds: answeredQuestionIds,
        updateSelectedSection: updateSelectedSection,
        shouldAutoSelectFirstQuestion: shouldAutoSelectFirstQuestion,
        hideOverviewHeader: hideOverviewHeader,
        onQuestionSelected: onQuestionSelected,
        onSelectCarouselQuestion: onSelectCarouselQuestion
      })
    })]
  });
};